import { DocumentList } from "@portal/types/entities/documents";
import { GridColumnProps } from "@sinecycle/growcomponents";
import { useMemo } from "react";
import { Actions } from "./Actions/Actions";
import { AssociatedWith } from "./AssociatedWith/AssociatedWith";
import { DocumentTitle } from "./DocumentTitle/DocumentTitle";

function useColumns() {
  function handleColumns() {
    const columns: GridColumnProps<DocumentList> = [
      {
        colId: "Title",
        headerName: "Title",
        cellRenderer: DocumentTitle,
        pinned: "left",
        initialWidth: 300,
      },
      {
        colId: "DESC",
        headerName: "Description",
        cellRenderer: "textCell",
        field: "description",
        cellRendererParams: {
          textCellProps: {
            ellipsis: {
              tooltip: {
                placement: "top",
              },
            },
          },
        },
      },
      {
        colId: "TYPE",
        headerName: "Document Type",
        cellRenderer: "textCell",
        field: "type.name",
        cellRendererParams: {
          textCellProps: {
            ellipsis: {
              tooltip: {
                placement: "top",
              },
            },
          },
        },
      },
      {
        colId: "CREATED_DATE",
        headerName: "Added on",
        cellRenderer: "dateCell",
        field: "created_at",
        sortable: true,
      },
      {
        colId: "ADDED_BY",
        headerName: "Added by",
        cellRenderer: "textCell",
        field: "created_by",
        cellRendererParams: {
          textCellProps: {
            ellipsis: {
              tooltip: {
                placement: "top",
              },
            },
          },
        },
        valueGetter: (params) => {
          return params.data?.created_by
            ? `${params.data?.created_by?.first_name} ${
                params.data?.created_by?.last_name ?? ""
              }`
            : "-";
        },
      },
      {
        colId: "ASSOCIATED_WITH",
        headerName: "Associated with",
        cellRenderer: AssociatedWith,
        flex: 1,
      },
      {
        colId: "ACTIONS",
        cellRenderer: Actions,
        pinned: "right",
        lockVisible: true,
      },
    ];
    return columns;
  }

  const defaultColConfigs = useMemo(handleColumns, []);

  return { defaultColConfigs };
}

export { useColumns };
